import './CollectionCreate.css';

import React, { useState } from 'react';

import { Button, Form, Icon, Modal } from 'semantic-ui-react';

const CollectionCreate = ({ handleSubmit }) => {

    const [modalOpen, setModalOpen] = useState(false);

    const handleSave = (e) => {
        handleSubmit(e);
        setModalOpen(false);
    }

    return (
        <Modal
            className="modal collection-create"
            closeIcon
            trigger={<Button icon
                onClick={() => setModalOpen(true)}
                data-tooltip="Create a new sites collection"
                data-inverted=""
                data-tut="reactour__collections__create"
            >
                <Icon name='edit' />
            </Button>}
            open={modalOpen}
            onClose={() => setModalOpen(false)}
        >
            <Modal.Header>Create a new collection</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <p>Create a new empty collection.
                        </p>
                    <div className="ui divider"></div>
                </Modal.Description>
                <Form onSubmit={handleSave}>
                    <Form.Field>
                        <label>Collection Name</label>
                        <input id="collection_name" />
                    </Form.Field>
                    <Form.Button color='green' inverted>
                        <Icon name='checkmark' />Save
                    </Form.Button>
                </Form>
            </Modal.Content>
        </Modal>
    )

};

export default CollectionCreate;